import { usePermissions } from "ra-core";
import type { ReactNode } from "react";
import { AccessDenied } from "@/components/admin/access-denied";

/**
 * Renders children for active admins only. `getPermissions` yields "admin" for
 * an enabled admin; reps and disabled accounts get the access-denied page.
 */
export const RequireAdmin = ({ children }: { children: ReactNode }) => {
  const { permissions, isPending } = usePermissions();
  if (isPending) return null;
  if (permissions !== "admin") return <AccessDenied />;
  return <>{children}</>;
};
